import { FC } from 'react';

import SunshineTag from 'components/_core/SunshineTag';

import { PaymentCardListTable_ItemFragment } from '../../../../../../hooks/usePaymentCardsList/paymentCardsList.gql';
import { isCreatedCard } from '../../utils';
import {
  getPaymentCardStatusBadgeColor,
  getPaymentCardStatusBadgeLabel,
} from './utils';

interface PaymentCardListTableRowStatusBadgeProps {
  paymentCard: PaymentCardListTable_ItemFragment;
}

export const PaymentCardListTableRowStatusBadge: FC<
  PaymentCardListTableRowStatusBadgeProps
> = ({ paymentCard }) => {
  const badgeLabel = getPaymentCardStatusBadgeLabel(paymentCard);
  const badgeColorScheme = getPaymentCardStatusBadgeColor(paymentCard);

  return (
    <SunshineTag
      colorScheme={badgeColorScheme}
      icon={isCreatedCard(paymentCard) ? 'hourglass' : undefined}
      noOfLines={1}
      size="sm"
    >
      {badgeLabel}
    </SunshineTag>
  );
};
